export default function Accounts() {
  return <h1>Accounts</h1>;
}
